import React from 'react';

export type DocManagementUploadContextProps = {
    showUploadModal: boolean;
    setShowUploadModal: (show: boolean) => void;
};

const noOp = () => {
    // No-op
};

const DocManagementUploadContext = React.createContext<DocManagementUploadContextProps>({
    showUploadModal: false,
    setShowUploadModal: noOp,
});

export default DocManagementUploadContext;
